import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api";

export const WhatsAppFab = () => {
  const [number, setNumber] = useState("");

  useEffect(() => {
    api.get("/config/fees").then((r) => setNumber((r.data?.whatsapp || "").replace(/\D/g, ""))).catch(() => {});
  }, []);

  if (!number) return null;

  const normalized = number.startsWith("55") ? number : `55${number}`;
  const msg = encodeURIComponent("Olá! Vim pelo site da TSBRASIL Ar-Condicionado e gostaria de agendar um atendimento.");
  const url = `https://wa.me/${normalized}?text=${msg}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-[#25D366] hover:bg-[#20bd5a] text-white font-semibold px-4 py-3 rounded-full shadow-2xl shadow-emerald-500/30 transition-all hover:scale-105"
    >
      <MessageCircle className="w-5 h-5" fill="white" strokeWidth={0} />
      <span className="hidden sm:inline text-sm">WhatsApp</span>
    </a>
  );
};
